import { render, staticRenderFns } from "./ClientNeedsGenerator.vue?vue&type=template&id=00171704&scoped=true&"
import script from "./ClientNeedsGenerator.vue?vue&type=script&lang=js&"
export * from "./ClientNeedsGenerator.vue?vue&type=script&lang=js&"
import style0 from "./ClientNeedsGenerator.vue?vue&type=style&index=0&id=00171704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00171704",
  null
  
)

export default component.exports